import React, { FC } from 'react';

import { Energimerkeversjon } from '../../types/energimerke';

import { EnergimerkeV2025 } from './v2025/energimerkeV2025';
import EnergimerkeV2023 from './v2023/energimerkeV2023';
import { EnergimerkeProps } from './energikarakter';

export const Energimerke: FC<EnergimerkeProps> = ({ energimerke }) => {
  switch (energimerke?.version) {
    case Energimerkeversjon.V2025:
      return <EnergimerkeV2025 energimerke={energimerke} />;
    case Energimerkeversjon.V2023:
      return <EnergimerkeV2023 energimerke={energimerke} />;
    default:
      // TODO: Decide how to handle unsupported versions
      console.warn('Unsupported energimerke version');
      return <EnergimerkeV2023 energimerke={energimerke} />;
  }
};
